import axiosInstance from "../utils/api";

import endpoints from "../constants/endpoints";



export const DesignApi = {

    fetchProductDetailForDesign: async (subCategoryId) => {
        try {
            const response = await axiosInstance.get(endpoints.fetchTemplateDetailForDesigns(subCategoryId));
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    saveUserCustomizeProductDesign: async (data) => {
        try {
            const response = await axiosInstance.post(endpoints.saveCustomizeProductDesign, data);
            return response.data;
        } catch (error) {
            throw error;
        }
    }
    ,
    fetchUserCustomizeProductDesign: async (projectId) => {
        try {
            const response = await axiosInstance.get(endpoints.fetchCustomizedProductDesign(projectId));
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    updateCustomizeProductDesign: async (projectId, data) => {
        try {
            const response = await axiosInstance.put(endpoints.updateCustomizedProductDesign(projectId), data);
            return response.data;
        } catch (error) {
            throw error;
        }
    }
    ,

    getAllCustomerCustomizedDesign: async () => {
        try {
            const response = await axiosInstance.get(endpoints.fetchAllUserCustomizedProductDesigns);
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    searchAndFilterUserCustomizedDesign: async (searchTerm, filterParams) => {
        try {
            const response = await axiosInstance.post(endpoints.filterUserCustomizedDesign(searchTerm), filterParams);
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    deleteUserCustomizedDesign: async (projectId) => {
        try {
            const response = await axiosInstance.delete(endpoints.deleteUserCustomizedDesign(projectId));
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    

}